import type { PositionInfo, PositionType, TipConfig, TipModifiers } from './type'

export function getTipPosition({ positionType, mouseEvent, rect, config }: PositionInfo) {
  let { x, y } = rect
  const { height, width } = rect

  const halfH: number = +(height / 2).toFixed(2)
  const halfW = +(width / 2).toFixed(2)
  const offsetMap = {
    top: {
      left: x + halfW,
      top: y - 8,
      transform: 'translate(-50%, -100%)'
    },
    topLeft: {
      left: x,
      top: y - 8,
      transform: 'translate(-50%, -100%)'
    },
    topRight: {
      left: x + width,
      top: y - 8,
      transform: 'translate(50%, -100%)'
    },
    bottom: {
      left: x + halfW,
      top: y + height + 8,
      transform: 'translate(-50%, 0)'
    },
    bottomLeft: {
      left: x,
      top: y + height + 8,
      transform: 'translate(-50%, 0)'
    },
    bottomRight: {
      left: x + width,
      top: y + height + 8,
      transform: 'translate(50%, 0)'
    },
    left: {
      left: x - 8,
      top: y + halfH,
      transform: 'translate(-100%, -50%)'
    },
    leftTop: {
      left: x - 8,
      top: y,
      transform: 'translate(-100%, -50%)'
    },
    leftBottom: {
      left: x - 8,
      top: y + height,
      transform: 'translate(-100%, -50%)'
    },
    right: {
      left: x + width + 8,
      top: y + halfH,
      transform: 'translate(0, -50%)'
    },
    rightTop: {
      left: x + width + 8,
      top: y,
      transform: 'translate(0, -50%)'
    },
    rightBottom: {
      left: x + width + 8,
      top: y + height,
      transform: 'translate(0, -50%)'
    }
  }

  const offsetDesc: {
    left: number | string
    top: number | string
    transform?: string
  } = offsetMap[positionType as PositionType] || {
    left: mouseEvent?.clientX,
    top: mouseEvent?.clientY + 16
  }

  const { offsetX = 0, offsetY = 0, topSet, leftSet } = (config as any) || {}

  offsetDesc.left = offsetDesc.left + offsetX
  offsetDesc.top = offsetDesc.top + offsetY

  if (typeof leftSet === 'function') {
    offsetDesc.left = leftSet({ offsetMap, mouseEvent })
  }

  if (typeof topSet === 'function') {
    offsetDesc.top = topSet({ offsetMap, mouseEvent })
  }

  return offsetDesc
}

export function getTipPositionStyle(positionInfo: PositionInfo) {
  const { left, top, transform } = getTipPosition(positionInfo)

  return {
    left: `${left}px`,
    top: `${top}px`,
    transform: transform || ''
  }
}

/**
 * @description: 查询tip的展示位置，未定义则跟随鼠标位置
 * @param {*}
 * @return {*}
 */
export function getPositionModifier(config: TipConfig, modifiers: TipModifiers): PositionType | '' {
  const positionModifierKeys = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight',
    'left',
    'leftTop',
    'leftBottom',
    'right',
    'rightTop',
    'rightBottom'
  ] as PositionType[]
  return (
    positionModifierKeys.find(key => {
      return modifiers[key]
    }) ||
    config.positionType ||
    ''
  )
}

export function getArrowType(positionType: string = '') {
  const matchRes = positionType.match(/([a-z]+)/) || ['']
  return matchRes[0]
}
